import { theme, media, pxToRem } from '@vfit/shared/themes';
import styled from '@emotion/styled';

export const FaqContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 23px 0 24px;

  ${media.tablet`
    margin: 0 69px 0 32px;
  `}

  ${media.desktop`
    margin: 0 80px;
  `}
`;

export const FaqAccordionWrapper = styled.div`
  a {
    color: ${theme.colors.text.primary} !important;
    font-weight: ${theme.typography.fontWeight.bold};

    :visited {
      color: ${theme.colors.text.primary} !important;
    }

    :hover {
      color: ${theme.colors.text.brand} !important;
    }
  }
`;

export const FaqShowMore = styled.div`
  .capitalize-first {
    text-transform: lowercase;
  }
  .capitalize-first::first-letter {
    text-transform: uppercase;
  }
  margin: 0 auto;
  margin-top: ${theme.spacing.xl};
  margin-bottom: ${theme.spacing.xl};

  ${media.bigDesktop`
    margin-top: ${theme.spacing['2xl']};
  `}

  .button-slide-container {
    width: 279px;

    button,
    a {
      padding: 10.5px 0;
    }

    ${media.tablet`
      width: 216px;
    `}

    ${media.bigDesktop`
      width: 324px;
    `}
  }
`;

export const Text = styled.div`
  div {
    margin-bottom: 0;

    p {
      margin-block: 0;
    }
  }
`;

export const DisclaimerContainer = styled.div`
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.text.secondary};

  img {
    width: 18px;
  }
`;

export const DisclaimerText = styled.div`
  font-size: ${theme.typography.fontSize.body2};
  line-height: ${theme.typography.lineHeight.body2};
`;

export const AccordionText = styled.div`
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.regular};
  font-size: ${theme.typography.fontSize.body2};
  line-height: ${theme.typography.lineHeight.body2};
  margin: 48px 23px 31px;
`;

export const TopText = styled.div`
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.regular};
  font-size: ${pxToRem(30)};
  line-height: ${pxToRem(38)};
  text-align: center;

  ${media.tablet`
    font-size: ${theme.typography.fontSize.h2};
    line-height: ${theme.typography.lineHeight.h2};
  `}
`;

